import { FC } from "react";

import styles from "./Button.module.css";

interface ButtonProps {
    margin?: string;
    background?: string;
    color?: string;
    imageSrc?: string;
    size?: "small" | "medium" | "large" | "xlarge";
    label?: string;
    cursor?: string;
    href?: string;
    onClick?: (args: any) => any;
}

const Button: FC<ButtonProps> = (props: ButtonProps) => {
    const customStyle = {
        backgroundColor: props.background ?? "#08f",
        margin: props.margin ?? "0 5px",
        backgroundImage: `url(${props.imageSrc ?? ""})`,
        color: props.color ?? "white",
        cursor: props.cursor ?? "pointer",
    };

    let classes = "";

    if (props.imageSrc != null && props.label != null) {
        classes = `${styles.text} ${styles.image} ${styles.base}`;
    } else if (props.imageSrc != null) {
        classes = `${styles.image} ${styles.base}`;
    } else if (props.label != null) {
        classes = `${styles.text} ${styles.base} `;
    } else {
        classes = styles.base;
    }

    switch (props.size) {
        case "small":
            classes += ` ${styles.small}`;
            break;
        case "medium":
            classes += ` ${styles.medium}`;
            break;
        case "large":
            classes += ` ${styles.large}`;
            break;
        case "xlarge":
            classes += `${styles.xlarge}`;
            break;
    }

    return (
        <div className={classes} style={customStyle} onClick={props.onClick}>
            {props.label}
        </div>
    );
};

export default Button;
